import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetFinancingDataAdsUseCase extends UseCase {
  constructor({service, logger, config}) {
    super()
    this._service = service
    this._logger = logger
  }

  /**
   * @param {String} dealerId
   * @param {Number} registrationYear
   * @param {Number} vehiclePrice
   */
  @tracer({metric: 'GetFinancingDataAdsUseCase#execute'})
  @inlineError
  async execute({adId, entry, terms}) {
    return this._logger.trace('GetFinancingDataAdsUseCase', () => this.run({adId, entry, terms}), {
      tags: [{key: 'usecase', value: 'GetFinancingDataError'}],
      logErrors: true
    })()
  }

  async run({adId, entry, terms}) {
    const [getFinancingDataError, getFinancingDataResponse] = await this._service.execute({
      adId,
      entry,
      terms
    })

    if (getFinancingDataError !== null) {
      throw getFinancingDataError
    }
    return getFinancingDataResponse.toJSON()
  }
}
